export default class SingleOffersController {

    init() {
        this.bindUi()
        this.bindEvents()
        this.initNiceSelect()
    }

    bindUi() {
        this.$select = document.querySelector('.js-single-offers_select')
        this.$selects = document.querySelectorAll('.js-single-offers_niceSelect')
    }

    bindEvents() {
        this.$select.addEventListener('change', (event) => { this.updateOffre(event) })
    }

    updateOffre(event) {
        if (event.target.value) {
            const selectedKey = event.target.value;
            const url = new URL(window.location.href);
            url.searchParams.set('duree_engagement', selectedKey);
            const newUrl = url.toString();
    
            window.location.href = newUrl;
        }
    }

    initNiceSelect() {
        this.$selects.forEach(select => {            
            NiceSelect.bind(select);
        })
    }
}
